// extracted by mini-css-extract-plugin
module.exports = {"toggler":"RarumTabs_toggler__W2qGn","tabContainer":"RarumTabs_tabContainer__Qtzko","tab":"RarumTabs_tab__jvnTB","large":"RarumTabs_large__5MoXN"};